import React from 'react';
import { Settings, Construction } from 'lucide-react';
import SuperAdminLayout from '@/components/superadmin/SuperAdminLayout';

const SuperAdminSettings = () => {
  return (
    <SuperAdminLayout>
      {/* Page Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-white">Settings</h1>
        <p className="text-gray-400 text-sm mt-1">Platform configuration</p>
      </div>

      {/* Placeholder Content */}
      <div className="bg-[#161B22] border border-gray-800 rounded-lg p-12 text-center">
        <div className="w-16 h-16 bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-4">
          <Construction className="w-8 h-8 text-gray-600" />
        </div>
        <h2 className="text-xl font-semibold text-white mb-2">Coming Soon</h2>
        <p className="text-gray-400 max-w-md mx-auto">
          Platform settings and configuration options will be available here. 
          This section is currently under development.
        </p>
      </div>
    </SuperAdminLayout>
  );
};

export default SuperAdminSettings;
